import { BaseApi as Base } from '@micromag/data';

class OrganisationsContactsApi extends Base {
    find(contact) {
        return this.requestGet(
            this.route('organisations.contacts.show', {
                contact,
            }),
        );
    }

    findByType(type) {
        return this.requestGet(
            this.route('organisations.contacts.type', {
                type,
            }),
        );
    }

    get(query) {
        return this.requestGet(this.route('organisations.contacts.index'), query);
    }

    create(data) {
        return this.requestPost(this.route('organisations.contacts.store'), data);
    }

    update(contact, data) {
        return this.requestPut(
            this.route('organisations.contacts.update', {
                contact,
            }),
            data,
        );
    }
}

export default OrganisationsContactsApi;
